import { useNavigate, useParams } from 'react-router-dom';
import { FeatureThemeProvider } from '../../../theme/FeatureThemeProvider';
import { TEMPLATE_BASE_PATH } from '../constants/templateApi';
import TemplateForm from '../components/form/TemplateForm';

export default function TemplateEditPage() {
  const navigate = useNavigate();
  const { templateName, botNumber } = useParams();

  return (
    <FeatureThemeProvider>
      <TemplateForm
        templateName={templateName}
        botNumber={botNumber}
        onBack={() => navigate(`${TEMPLATE_BASE_PATH}/template-list`)}
      />
    </FeatureThemeProvider>
  );
}
